import React from 'react';
import intl from 'react-intl-universal';
import { Avatar, Dropdown, Menu } from 'antd';
import store from '@/store';
import userIncon from '@/assets/Collaboration/sign-in.svg';
import userSignUpcon from '@/assets/Collaboration/sign-up.svg';

export default function UnLoggedInAvatar() {
    const { isOnPremiseDeployMode } = store.appStore;
    const menu = (
        // @ts-ignore
        <Menu className="user-dropdown-menu-wrapper">
            <Menu.Item style={{ cursor: 'pointer' }} onClick={onLoginIn}>
                <span className={'can_click'}>
                    <Avatar size="small" shape="square" src={userIncon}></Avatar>
                    <span>{intl.get('user.signIn')}</span>
                </span>
            </Menu.Item>
            {!isOnPremiseDeployMode && (
                <Menu.Item onClick={onSignUp}>
                    <span className={'can_click'}>
                        <Avatar size="small" shape="square" src={userSignUpcon}></Avatar>
                        <span>{intl.get('user.signUp')}</span>
                    </span>
                </Menu.Item>
            )}
        </Menu>
    );
    return (
        // @ts-ignore
        <Dropdown overlay={menu} placement="bottomRight">
            <i className="login-avatar icon-btn" />
        </Dropdown>
    )
}

function onLoginIn() {
    if (!window.__online__) {
        store.appStore.doNotifyErrors('offline');
        return;
    }
    store.userStore.loginIn();
}

function onSignUp() {
    if (!window.__online__) {
        store.appStore.doNotifyErrors('offline');
        return;
    }
    store.userStore.signUp(false);
}
